<div class="data-monitoring-page">
  <div class="page-header">
    <div class="page-header__title">
      <h2>{{ 'DATA_MONITORING_TITLE' | translate }}</h2>
      <p>{{ 'DATA_MONITORING_LEAD' | translate }}</p>
    </div>
    <div class="header-actions">
      <div class="header-actions__year">
        <span class="header-actions__label">{{ 'Year' | translate }}</span>
        <msf-select
          [model]="year()"
          (modelChange)="selectYear($event)"
          [options]="yearOptions()"
          optionLabel="label"
          optionValue="value"
          translateBy="none"
          width="110px"
        />
      </div>
      <app-secondary-button title="Refresh" icon="refresh" (action)="refresh()"></app-secondary-button>
    </div>
  </div>

  @if (updatedText()) {
    <p class="updated-at">{{ 'DATA_MONITORING_UPDATED_AT' | translate: { time: updatedText(), minutes: refreshMinutes } }}</p>
  }

  @if (loadFailed()) {
    <div class="error-message">{{ 'DATA_MONITORING_LOAD_FAILED' | translate }}</div>
  }
  @for (failure of failures(); track failure.source) {
    <div class="error-message">
      {{ 'DATA_MONITORING_SOURCE_FAILED' | translate: { source: (failure.labelKey | translate), error: failure.error } }}
    </div>
  }

  @if (loading() && !snapshot()) {
    <app-loading [loading]="true"></app-loading>
  } @else if (board()) {
    <div class="layout">
      <app-data-monitoring-board
        [view]="board()!"
        [monthNameKey]="monthNameKey()"
        [year]="year()"
        [isFirstMonth]="isFirstMonth()"
        [isLastMonth]="isLastMonth()"
        [forecastDays]="forecastDays"
        [forecastHorizon]="forecastHorizon"
        (previousMonth)="previousMonth()"
        (nextMonth)="nextMonth()"
        (toggleGroup)="toggleGroup($event)"
      ></app-data-monitoring-board>
      <app-data-monitoring-year-panel
        [year]="year()"
        [totalProblems]="totalProblems()"
        [months]="yearPanel()"
        (openMonth)="openMonth($event)"
        (goToRow)="goToRow($event)"
      ></app-data-monitoring-year-panel>
    </div>
  }
</div>
